export const onlineCheckboxProps = {
	my: "10px !important",
};
